export const getSetubalData = () => ({
  name: "Setúbal",
  country: "Portugal",
  description: "La péninsule de Setúbal est réputée pour ses vins doux naturels (Moscatel de Setúbal) et ses rouges puissants à base de Castelão.",
  type: "region",
  subregions: [
    { name: "Palmela", area: "4,000 ha", percentage: "50%", description: "Rouges puissants de Castelão" },
    { name: "Setúbal", area: "4,000 ha", percentage: "50%", description: "Moscatel doux naturel" }
  ],
  mapAreas: [
    { region: "Palmela", x: 51, y: 62, color: "#4B164C", size: 3 },
    { region: "Setúbal", x: 53, y: 64, color: "#6d2c7a", size: 3 }
  ],
  statistics: {
    totalArea: "8,000 ha",
    production: "200,000 hl",
    wineries: "30+ domaines",
    appellations: "2 sous-régions",
    exportPercentage: "22%"
  },
  characteristics: {
    climate: "Climat méditerranéen, influence atlantique",
    soil: "Sols sableux, argilo-calcaires",
    viticulture: "Cépages Castelão, Moscatel, vendanges manuelles"
  },
  wineStyles: {
    red: "Rouges puissants, Castelão dominant",
    fortified: "Moscatel de Setúbal, vin doux naturel célèbre"
  },
  history: "Setúbal est célèbre pour ses vins doux naturels depuis le Moyen Âge. Palmela produit des rouges puissants et fruités.",
  foodPairing: "Fromages de brebis, pâtisseries portugaises, plats de la péninsule de Setúbal"
}); 